export const VCCM_AUTH_MODULE = 'vccm';
export const VRS_AUTH_MODULE = 'vrs';
export const API_AUTH_MODULE = 'api';
export const VRS_OPERATIONS_AUTH_MODULE = 'vrsOperations';
export const VRS_REPORTING_AUTH_MODULE = 'vrsReporting';
export const VRS_SUPERUSER_AUTH_MODULE = 'vrsSuperUser';

export const all = [
  VCCM_AUTH_MODULE,
  VRS_AUTH_MODULE,
  API_AUTH_MODULE,
  VRS_OPERATIONS_AUTH_MODULE,
  VRS_REPORTING_AUTH_MODULE,
  VRS_SUPERUSER_AUTH_MODULE,
];

// This modules can be applied to other organisational unit such as companies, countries, global as well as sites
// Our basic modules (VCCM, VRS and API-(field service is global now)) can only be applied to sites
export const generalModules = [
  VRS_OPERATIONS_AUTH_MODULE,
  VRS_REPORTING_AUTH_MODULE,
  VRS_SUPERUSER_AUTH_MODULE,
  API_AUTH_MODULE,
];

export const allModulesRegexStr = `^(${all.join('|')})$`;

export const foreign = [
  VRS_AUTH_MODULE,
  API_AUTH_MODULE,
  VRS_OPERATIONS_AUTH_MODULE,
];

export const VCCM_TOKEN_ISSUER = 'vccm-authenticator';

export const getCognitoKeys = (userPoolId) => {
  const commonKey = {
    alg: 'RS256',
    e: 'AQAB',
    kty: 'RSA',
    use: 'sig',
  };
  switch (userPoolId) {
    case 'us-west-2_UqXT7H8oa':
      return {
        keys: [
          ({
            ...commonKey,
            kid: '+xlqoYUw/p+tMC/jTkwsen8amQYEM0XCntslvL8Q+0g=',
            n: 'vF-1vqyBhS_cro9yT_MlQjIc7eyRK2m2KMPcWEhyrn-4HkpLX72UNiT3jnLZ8BBMM0QL21hFsoscbQk8yPVCfEznR3SlajnGSt_zMHeU8_yX8U6YI07aQKchGfwjQnsYSQa0YBpq7D3VTCvoWHQuSkkcQjThgXwQeqTVEian4lR9_VvVF87qZoNsZ4GCNA6y5cSIBZLnQdZBomYGYjXpqcQdDFlFOkTN_GPH8yTEO6Lk8aRYNjrSE1tSAm30Xzrhkw6H20PyUPzXyO62M7WbpaEag4rZuRoVBPawDQYkDiNl6l1EZbIiOg9x6OHnjZOXtBAq7ZpGzSLW7yvvRDKhOQ',
          }),
          ({
            ...commonKey,
            kid: 'apPHFeftQwbuhGRHmrnsiIfQteAE1RNwIagyMI4/VCQ=',
            n: 'kAGu9R5DyfBYj5IOEpPzqRK7kXFZa2cgb9CwHJlqjPKIGCRXlva5jDLqLFXgCuJeu7yLnSfDnoeGv18jesZIA0Zek1Sc9zKkLURTKCbRohUJCNe_H-Wkl2h35LGBEILmlaAFaiHeiTKGx-dIpu-kQFF3fl72Iv4W4kKARH8c9YBhLTGI-b_yQQCmQmaj7GAFJhf0HlTLVCaq4jjL1zvtesLwvckf3To_zhSdNZaSOGxX7A-cktbD6NYRSShFQEMBAdUpo2Yj-C_cY9nWhTsWAUcHUeLPxGBA9zwW1_2-3k02B3x6qrntwhJdOnOJdiTjLxg484qkxag7NJE8GwPEZQ',
          }),
        ],
      };
    case 'us-west-2_0C51LAbX0':
      return {
        keys: [
          ({
            ...commonKey,
            kid: 'mLt2V6NE5qW/8GYx6lxWyI2y/EKaJavbZyLneOTBaD0=',
            n: 'gUFsmRO2lrBm-xqgoiOG6soGZwUy3Wal63AyMbzXRtPuUTmSzeuOG8TpKvkb9Q-ic0hT-avSncskb6c4Lp0B1KqPSjXsdiOAx-4jRMLX4qlClhdjDNvcijUZfq0AfesRDDuR1s6dt2VlbzvY6W6p3RmNcaj__DJ-LnHoidHofsobkaR7RGheaO4_dFx_jzGGFP-f0JwzTmG5SPKroIGsiGXHRFdWYDtPuhsyGHaef-nhggLUTzmCTqGHA3coF3aMVomiykwLgZcsLvQjenlyWlPg2wklmqtf-ixjEEykxbLOe1_FOzX0j-02SlrrHzR1L3WBU9mz95jrJyt_nOL2iw',
          }),
          ({
            ...commonKey,
            kid: 'H+ONlMNWoZ6QRwRVIcuot69Zxc82e/2U3Ynr58kPib0=',
            n: 'gKJFT7kGLZcwyzmEu3xdRkmVk9Rx56uODbUxC_WI1TOJNETBZFDucqeoRnMv0tmEkkO-Bd5E8CFoTOsDADUKrWLqSwf4bS-olSckCRrjITwkug67_7C1TmzdsmHHINOk_Cr5jE2E25Cpp3Iegx3EmuhKB4ImQSPOTe5cNPv5fiNiQNMt3e_daoB3h6b2vOkEWnNyE0Gd6NoVDbVCSUGZaYZDh3G25QAijHm_r3EaSTJYo6TWqxfGiEU7lT-eD9czwyeZicgnBGZqlxBQ_YrcFC2K8glQfCbd7v21hy6S-o1Tb2Sl5IWTPxZiwsD51yMhjMxgVwRkzV4YMtoxuaRf5Q',
          })]
      };
    case 'us-west-2_4Ymwhh3Lz':
      return {
        keys: [
          ({
            ...commonKey,
            kid: 'vOdFXgRWcmjqc+KuDMEcL9iPxGDh/OqWcFU2Jb335L4=',
            n: 'kHd6Lo_uJZ1wtca53mvdg7vVdyYI97L3UyACmfhoEM_wthpHh6Lby1q5Mx0CSAGGBCps038gnfoSytixsKDU9q4Kyd2oajzKEUApOmBkhVbIFV5F3OuL7zA29zHhehcNjw56E38-OrCWJLTl1f7yh-803VZzEFwwoE61E2Ujnoett7rqTO7-w59o0gAvWp2F4NFkMXB3ggaJqBGZyGBzHOA_DOXR3t3alJNP1Kql6YF944a-gyDZOiI9WtN3CQQEujqnik6W3dvLrw4VCCLJy2Sf0IwRsz5RZmYxOzrwhdt5jXG2FQSbXkXbBoE8IjK8eEtIc-Lcj5Htr7cV64d3hw', 'use': 'sig'

          }),
          ({
            ...commonKey,
            kid: 'qlWt6gqjgKCrZOLNii1n3IP8q840JbIJssz39lkqbGE=',
            n: 'xhkMxyFe6lvsWvJRR_qdpfDR8MFjivmvA4PcbrjKT3eddNx9rWNKnplFHXAv7S0qCmfRBO4jKzh5rJGNsA_-L-Z_-IpQvoK4s5jj5oHqRxXqadWDDQbTzWsAj-WXTR0rvkJIL__dmVTQI9mB0Gd8fzblfPnI6nji5F9HwR-CjPSkQKKQ3K7Dvvjk3Wb2gVSoVXreEqWkk89RgBI6AH-O6cj0kx_R1qUjWCc1sJnUnWDK1u2QocC0mVdzudcYEJMRChuW97Ce5Rt_QEfM9QI89byKApekTBoktpYjF7qXkf9NMgPbspy08GXL5BsfnMcAAkjGosvnHWyeCRmiV_tcIQ',
          })
        ]
      };
  }
};
